module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-SemiBold-c74b469cee2197b1ca7233ea32643f22.woff";